import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {ROLES} from '../../../common/constants';
import {withLoadedUser} from '../../../login/containers/AuthBase';
import UserBillingDetails from '../components/UserBillingDetails';
import MerchantBillingDetails from '../components/MerchantBillingDetails';
import AdminBillingDetails from '../components/AdminBillingDetails';

const Billing = ({currentUser}) => {
  if (currentUser.role === ROLES.ADMIN) {
    return <AdminBillingDetails />;
  } else if (currentUser.role === ROLES.MERCHANT) {
    return <MerchantBillingDetails/>;
  } else if (currentUser.role === ROLES.USER) {
    return <UserBillingDetails/>;
  }
};

Billing.propTypes = {
  currentUser: PropTypes.shape({
    role: PropTypes.string.isRequired,
  }).isRequired,
};

export default compose(
  withLoadedUser,
)(Billing);
